(function ($) {

  $('.fa-circle-question').mouseenter(function () {
    $(this).siblings(".tooltip").fadeIn(300);
  }).mouseleave(function () {
    $(this).siblings(".tooltip").fadeOut(300);
  });

})(jQuery);
